/**
 * Canonical Hebrew labels for the tunable scheduler-weight keys — the SINGLE
 * source of truth shared by the Algorithm Settings sliders (`WEIGHT_GROUPS` in
 * `tab-algorithm.ts`), the auto-tune change table (`formatWeightKey` in
 * `app.ts`), and the auto-tuner's live leader-diff preview
 * (`computeLeaderDiffLabel` in `auto-tuner.ts`).
 *
 * Kept in this tiny dependency-free module (no DOM / store / engine imports) so
 * the Node-safe `auto-tuner.ts` — whose `freezeEnv` is loaded by the Node
 * persistence build — can import the labels without dragging the web UI module
 * graph (`tab-algorithm.ts` → `data-transfer-ui` / `tutorial` / `ui-modal` …)
 * into the Node/persistence build. Replaces the former hand-maintained
 * `TUNED_LABELS` copy in `auto-tuner.ts` that risked drifting from the slider
 * labels.
 */
export const WEIGHT_FIELD_LABELS: Record<string, string> = {
  minRestWeight: 'הפסקה מינימלית גבוהה בין משימות',
  restPerGapWeight: 'חשיבות הפסקה בין משימות',
  l0FairnessWeight: 'שוויון עומס בכל השבצ"ק',
  seniorFairnessWeight: 'שוויון עומס לסגל בכל השבצ"ק',
  lowPriorityLevelPenalty: 'עונש דרגה בעדיפות נמוכה',
  dailyBalanceWeight: 'שוויון עומס יומי',
  notWithPenalty: 'עונש "אי התאמה"',
  taskNamePreferencePenalty: 'עונש אי-קיום העדפה',
  taskNameAvoidancePenalty: 'עונש שיבוץ לא-מועדף',
  taskNamePreferenceBonus: 'בונוס שיבוץ מועדף',
  splitPenalty: 'עונש פיצול משמרת',
};

/**
 * The exact weight label shown on its slider card in the Algorithm Settings UI.
 * Single source of truth (`WEIGHT_FIELD_LABELS`) so every surface renders
 * identical names instead of a drifting hand-maintained copy. Falls back to the
 * raw key for any non-weight field.
 */
export function getWeightFieldLabel(key: string): string {
  return WEIGHT_FIELD_LABELS[key] ?? key;
}
